/**
 * Returns accessibility props for an image:
 * - If `alt` or `title` is provided → { alt }
 * - If neither is available → { role: 'presentation' } (for decorative images)
 *
 * @param {Object} [item={}] - Image object
 * @param {Object} [item.value={}] - Image data
 * @returns {{ alt: string } | { role: 'presentation' }}
 */
const getImageAccessibilityProps = ({ value = {} } = {}) => {
  const { alt, title } = value;
  const computedAlt = alt || title;

  if (!computedAlt?.trim()) return { role: 'presentation' };
  return { alt: computedAlt };
};

export default getImageAccessibilityProps;
